<template>
  <button
    :type="type"
    :disabled="disabled || loading"
    :class="buttonClasses"
    v-bind="$attrs"
  >
    <svg
      v-if="loading"
      class="mr-2 h-4 w-4 animate-spin"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 0 1 8-8V0A12 12 0 0 0 0 12h4z" />
    </svg>
    <slot />
  </button>
</template>

<script>
const variantClassMap = {
  default: 'bg-accent text-accent-foreground hover:bg-hover',
  secondary: 'bg-muted text-foreground hover:bg-muted/80',
  outline: 'border bg-background text-foreground hover:bg-muted',
  destructive: 'bg-destructive text-destructive-foreground hover:opacity-90',
  success: 'bg-success text-success-foreground hover:opacity-90',
  ghost: 'bg-transparent text-foreground hover:bg-muted'
};

const sizeClassMap = {
  sm: 'h-8 px-3 text-xs',
  md: 'h-9 px-4 text-sm',
  lg: 'h-10 px-5 text-sm',
  xl: 'h-11 px-6 text-base'
};

export default {
  name: 'UiButton',
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'button'
    },
    variant: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: 'md'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClasses() {
      const variant = variantClassMap[this.variant] || variantClassMap.default;
      const size = sizeClassMap[this.size] || sizeClassMap.md;
      return [
        'inline-flex items-center justify-center rounded-md font-medium shadow-sm transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        'disabled:pointer-events-none disabled:opacity-50',
        this.fullWidth ? 'w-full' : '',
        variant,
        size
      ];
    }
  }
};
</script>
